<template>
	<div class="lg:grid lg:grid-cols-3 gap-6">
		<!-- Featured Card Skeleton -->
		<div
			class="lg:mb-0 lg:pr-5 border-b lg:border-b-0 border-slate-100 pb-6 lg:pb-0 py-4 lg:py-5"
		>
			<!-- Featured image -->
			<div
				class="w-full h-48 lg:h-48 bg-slate-300/[0.1] rounded-lg animate-pulse mb-4"
			></div>
			<!-- Featured title -->
			<div class="space-y-2 mb-3">
				<div class="h-6 bg-slate-300/[0.1] rounded animate-pulse"></div>
				<div class="h-6 bg-slate-300/[0.1] rounded animate-pulse w-4/5"></div>
			</div>
			<!-- Featured description -->
			<div class="space-y-2">
				<div class="h-4 bg-slate-300/[0.1] rounded animate-pulse"></div>
				<div class="h-4 bg-slate-300/[0.1] rounded animate-pulse w-5/6"></div>
				<div class="h-4 bg-slate-300/[0.1] rounded animate-pulse w-3/4"></div>
			</div>
		</div>

		<!-- Grid Cards Skeleton -->
		<div class="col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-6">
			<div
				v-for="i in 4"
				:key="i"
				class="lg:px-5 border-b lg:border-b-0 lg:border-l border-slate-100 py-4 lg:py-5"
				:class="{ 'lg:border-b': i <= 2 }"
			>
				<!-- Grid card title -->
				<div class="space-y-2 mb-2">
					<div class="h-5 bg-slate-300/[0.1] rounded animate-pulse"></div>
					<div class="h-5 bg-slate-300/[0.1] rounded animate-pulse w-4/5"></div>
				</div>
				<!-- Grid card description -->
				<div class="space-y-1.5">
					<div class="h-3.5 bg-slate-300/[0.1] rounded animate-pulse"></div>
					<div class="h-3.5 bg-slate-300/[0.1] rounded animate-pulse w-5/6"></div>
					<div class="h-3.5 bg-slate-300/[0.1] rounded animate-pulse w-2/3"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
// No props needed - pure skeleton component
</script>

<style scoped>
/* Enhanced pulsating animation */
@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.7;
	}
}

.animate-pulse {
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Staggered animation for more natural loading effect */
.animate-pulse:nth-child(1) {
	animation-delay: 0s;
}
.animate-pulse:nth-child(2) {
	animation-delay: 0.1s;
}
.animate-pulse:nth-child(3) {
	animation-delay: 0.2s;
}
.animate-pulse:nth-child(4) {
	animation-delay: 0.3s;
}
</style>
